export enum FolderRequestType {
  Single = "Single",
  ExistingGrouped = "Existing Grouped",
  NewGrouped = "New Grouped",
}
